import template from './onlineCourse.html';
import controller from './onlineCourse.controller';
// import './livecourse.scss';

let onlineCourseComponent = {
  bindings: { },
  controllerAs: 'vm',
    template,
    controller
};

export default onlineCourseComponent;



// WEBPACK FOOTER //
// ./client/app/modules/site/onlineCourse/onlineCourse.component.js